import htmlToDom from './lib/server/html-to-dom.js';

/**
 * When running on Node.js, use the server parser.
 * When bundling for the browser, use the client parser.
 *
 * @see {@link https://github.com/substack/node-browserify#browser-field}
 */


var htmlDomParser = htmlToDom;
var default_1 = htmlToDom;
htmlDomParser.default = default_1;

export { htmlDomParser as __moduleExports, htmlDomParser as default };
